"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _Field = _interopRequireDefault(require("../Field"));

var _hooks = require("../../hooks");

var _excluded = ["label", "value"],
    _excluded2 = ["caution", "className", "error", "help", "id", "label", "labelClassName", "onChange", "options", "required", "stacked", "success", "takeFocus", "wrapperClassName"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var generateOptions = function generateOptions(options) {
  return options === null || options === void 0 ? void 0 : options.map(function (_ref) {
    var label = _ref.label,
        value = _ref.value,
        props = _objectWithoutProperties(_ref, _excluded);

    return /*#__PURE__*/_react.default.createElement("option", _extends({
      value: value,
      key: "".concat(value) || label
    }, props), label);
  });
};

var Select = function Select(_ref2) {
  var caution = _ref2.caution,
      className = _ref2.className,
      error = _ref2.error,
      help = _ref2.help,
      id = _ref2.id,
      label = _ref2.label,
      labelClassName = _ref2.labelClassName,
      _onChange = _ref2.onChange,
      options = _ref2.options,
      required = _ref2.required,
      stacked = _ref2.stacked,
      success = _ref2.success,
      takeFocus = _ref2.takeFocus,
      wrapperClassName = _ref2.wrapperClassName,
      selectProps = _objectWithoutProperties(_ref2, _excluded2);

  var selectRef = (0, _react.useRef)(null);
  var validationId = (0, _hooks.useId)();
  var helpId = (0, _hooks.useId)();
  var hasError = !!error;
  (0, _react.useEffect)(function () {
    if (takeFocus) {
      selectRef.current.focus();
    }
  }, [takeFocus]);
  return /*#__PURE__*/_react.default.createElement(_Field.default, {
    caution: caution,
    className: wrapperClassName,
    error: error,
    forId: id,
    help: help,
    helpId: helpId,
    isSelect: true,
    label: label,
    labelClassName: labelClassName,
    required: required,
    stacked: stacked,
    success: success,
    validationId: validationId
  }, /*#__PURE__*/_react.default.createElement("select", _extends({
    "aria-describedby": help ? helpId : null,
    "aria-errormessage": hasError ? validationId : null,
    "aria-invalid": hasError,
    className: (0, _classnames.default)("p-form-validation__input", className),
    id: id,
    onChange: function onChange(evt) {
      return _onChange && _onChange(evt);
    },
    ref: selectRef
  }, selectProps), generateOptions(options)));
};

var _default = Select;
exports.default = _default;